import React, { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { WithTranslation, withTranslation } from 'react-i18next';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import useStickyWrapper from '../../hooks/useStickyWrapper';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import { windowService } from '../../utils/window.utils';
import { detectScrollDirectionForNavigationBar } from '../../utils/detectScrollDirectionForNavigationBar.utils';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import NavigationSection from '../@shared/navigationSection';
import { ContentHubSeriesNavigationBarFields, TNavigationBarProps } from '../@shared/navigationSection/types/navigationBar.types';

const ProductSeriesNavigationBarWrapper: FC<WithTranslation & TNavigationBarProps> = (props) => {
  const fields = props?.fields as ContentHubSeriesNavigationBarFields;
  const apiParams = typeof props?.params === 'object' && Object.keys(props?.params).length > 0;
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);
  let scrollPosition = 0;
  const stickyWrapperEle = useStickyWrapper();
  const [dropdownIsOpen, setshowPanel] = useState(false);

  const detectScrollDirection = (): void => {
    scrollPosition = detectScrollDirectionForNavigationBar(stickyWrapperEle, scrollPosition);
  };

  useEffect(() => {
    windowService().addEventListener('scroll', detectScrollDirection, false);
    return (): void => {
      windowService().removeEventListener('scroll', detectScrollDirection);
    };
  }, [stickyWrapperEle]); // eslint-disable-line

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive() && !apiParams) {
    return null;
  }

  return (
    <>
      <NavigationSection {...props} isEditorial={false} dropdownIsOpen={dropdownIsOpen} setshowPanel={setshowPanel} />
      {stickyWrapperEle &&
        createPortal(
          <NavigationSection {...props} isEditorial={false} sticky={true} dropdownIsOpen={dropdownIsOpen} setshowPanel={setshowPanel} />,
          stickyWrapperEle
        )}
    </>
  );
};

export default withTranslation()(withSitecoreContext()(ProductSeriesNavigationBarWrapper));
